import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { FetchModels } from '../types';
import { POST_REVIEW, POST_REVIEW_RESET } from '../actions/post-reviews';

export type PostRequestPerfActions =
  | ActionType<typeof POST_REVIEW.request>
  | ActionType<typeof POST_REVIEW.failure>
  | ActionType<typeof POST_REVIEW.success>
  | ActionType<typeof POST_REVIEW.cancel>
  | ActionType<typeof POST_REVIEW_RESET>;
export const postReviewIsPerforming = createReducer<boolean | null, PostRequestPerfActions>(null)
  .handleAction(POST_REVIEW.request, () => true)
  .handleAction(
    [POST_REVIEW.failure, POST_REVIEW.success, POST_REVIEW.cancel, POST_REVIEW_RESET],
    () => false,
  );

export type PostRevewErrorActions =
  | ActionType<typeof POST_REVIEW.request>
  | ActionType<typeof POST_REVIEW.failure>
  | ActionType<typeof POST_REVIEW.success>
  | ActionType<typeof POST_REVIEW.cancel>
  | ActionType<typeof POST_REVIEW_RESET>;
export const postReviewError = createReducer<
  FetchModels.PostReviewRequestError | null,
  PostRevewErrorActions
>(null)
  .handleAction(POST_REVIEW.failure, (_, { payload }) => {
    const result = payload instanceof Error ? payload.message : payload;
    return result;
  })
  .handleAction(
    [POST_REVIEW.cancel, POST_REVIEW.request, POST_REVIEW.success, POST_REVIEW_RESET],
    () => null,
  );

export type PostReviewResulActions =
  | ActionType<typeof POST_REVIEW.request>
  | ActionType<typeof POST_REVIEW.failure>
  | ActionType<typeof POST_REVIEW.success>
  | ActionType<typeof POST_REVIEW.cancel>
  | ActionType<typeof POST_REVIEW_RESET>;
export const postReviewResult = createReducer<'ok' | 'error' | 'cancelled' | null, PostReviewResulActions>(
  null,
)
  .handleAction(POST_REVIEW.request, () => null)
  .handleAction(POST_REVIEW_RESET, () => null)
  .handleAction(POST_REVIEW.failure, () => 'error')
  .handleAction(POST_REVIEW.success, () => 'ok')
  .handleAction(POST_REVIEW.cancel, () => 'cancelled');

export const postReviewReducer = combineReducers({
  isPerforming: postReviewIsPerforming,
  error: postReviewError,
  resultStatus: postReviewResult,
});

export type PostReview = ReturnType<typeof postReviewReducer>;
